import { portfolio } from "../data/portfolio";
import { SectionHead } from "../components/SectionHead";

export function Engineering() {
  const E = portfolio.engineering;

  return (
    <section id="engineering" className="md-section">
      <div className="md-container">
        <SectionHead
          num="04"
          eyebrow="Engineering & Systems"
          title="Models are the easy part."
          dek="Most of the job is the plumbing — queues, retries, budgets, and the one honest log line that tells you why the thing actually failed."
        />

        <div className="m3-eng">
          <div className="md-card md-card--outlined m3-eng__stack-card reveal">
            <div className="md-title-m" style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span className="material-symbols-rounded" style={{ color: "var(--md-sys-color-primary)" }}>build</span>
              Stack matrix
            </div>
            {E.stack.map((row) => (
              <div key={row.group} className="m3-eng__stack-row">
                <div className="md-label-l m3-eng__stack-label">{row.group}</div>
                <div className="m3-eng__stack-chips">
                  {row.reach.map((s) => (
                    <span
                      key={s}
                      className="md-chip md-chip--selected"
                      style={{ height: 28, padding: "0 12px", fontSize: 12 }}
                    >
                      {s}
                    </span>
                  ))}
                  {row.regular.map((s) => (
                    <span
                      key={s}
                      className="md-chip md-chip--assist"
                      style={{ height: 28, padding: "0 12px", fontSize: 12 }}
                    >
                      {s}
                    </span>
                  ))}
                  {row.ambient.map((s) => (
                    <span
                      key={s}
                      className="md-chip md-chip--assist"
                      style={{ height: 28, padding: "0 12px", fontSize: 12, opacity: 0.6 }}
                    >
                      {s}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="m3-eng__mid">
            <div className="md-card md-card--filled md-card__pad reveal">
              <div className="md-title-m" style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
                <span className="material-symbols-rounded" style={{ color: "var(--md-sys-color-primary)" }}>schema</span>
                {E.systemSketch.title}
              </div>
              <div className="md-body-s dim" style={{ marginBottom: 12 }}>
                {E.systemSketch.subtitle}
              </div>
              <img
                className="m3-eng__diagram-img"
                src={`${import.meta.env.BASE_URL}CertusHire_.png`}
                alt={E.systemSketch.title}
                loading="lazy"
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                  borderRadius: "var(--md-sys-shape-md)",
                  background: "var(--md-sys-color-surface-container-lowest)",
                }}
              />
              <ul className="m3-eng__diagram-notes md-body-m">
                {E.systemSketch.notes.map((n, i) => (
                  <li key={i}>
                    <span className="material-symbols-rounded">arrow_forward</span>
                    <span>{n}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="md-card md-card--outlined reveal" style={{ overflow: "hidden" }}>
              <div style={{ padding: "20px 20px 12px" }}>
                <div className="md-title-m" style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span className="material-symbols-rounded" style={{ color: "var(--md-sys-color-primary)" }}>timer</span>
                  Latency budget
                </div>
                <div className="md-body-s dim" style={{ marginTop: 4 }}>
                  {E.latency.title}
                </div>
              </div>
              <table className="m3-eng__table md-body-m">
                <thead>
                  <tr>
                    <th className="md-label-m">Stage</th>
                    <th className="md-label-m">p50</th>
                    <th className="md-label-m">p95</th>
                  </tr>
                </thead>
                <tbody>
                  {E.latency.rows.map((r) => (
                    <tr key={r.stage}>
                      <td>{r.stage}</td>
                      <td>{r.p50}</td>
                      <td>{r.p95}</td>
                    </tr>
                  ))}
                  <tr className="m3-eng__table-total">
                    <td>Total turn</td>
                    <td>{E.latency.total.p50}</td>
                    <td>{E.latency.total.p95}</td>
                  </tr>
                </tbody>
              </table>
              <div style={{ padding: "12px 20px 16px", display: "flex", gap: 8, flexWrap: "wrap" }}>
                <span
                  className="md-chip md-chip--assist"
                  style={{ height: 28, padding: "0 12px", fontSize: 12 }}
                >
                  <span className="material-symbols-rounded icon-20">flag</span>
                  &lt; 200 ms p50
                </span>
                <span
                  className="md-chip md-chip--assist"
                  style={{ height: 28, padding: "0 12px", fontSize: 12 }}
                >
                  <span className="material-symbols-rounded icon-20">flag</span>
                  &lt; 300 ms p95
                </span>
              </div>
            </div>
          </div>

          <div className="reveal">
            <div
              style={{
                display: "flex",
                alignItems: "end",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 12,
                marginBottom: 16,
              }}
            >
              <div>
                <div className="md-label-l" style={{ color: "var(--md-sys-color-primary)" }}>
                  Vocabulary
                </div>
                <h3 className="md-headline-s" style={{ margin: "4px 0 0" }}>
                  Distributed systems I think in.
                </h3>
              </div>
              <div className="md-chip-group">
                <span className="md-chip md-chip--selected" style={{ height: 28 }}>
                  <span className="material-symbols-rounded icon-20">check_circle</span>
                  Shipped
                </span>
                <span className="md-chip md-chip--assist" style={{ height: 28 }}>
                  <span className="material-symbols-rounded icon-20">contrast</span>
                  Used
                </span>
                <span className="md-chip md-chip--assist" style={{ height: 28, opacity: 0.7 }}>
                  <span className="material-symbols-rounded icon-20">school</span>
                  Studied
                </span>
              </div>
            </div>

            <div className="m3-eng__vocab-grid">
              {E.vocab.map((v) => (
                <div key={v.term} className={"m3-vocab-cell m3-vocab-cell--" + v.level}>
                  <span className="m3-vocab-cell__icon">
                    <span className="material-symbols-rounded">
                      {v.level === "shipped" ? "check_circle" : v.level === "used" ? "contrast" : "school"}
                    </span>
                  </span>
                  <div>
                    <div className="md-title-m m3-vocab-cell__term">{v.term}</div>
                    <div className="md-body-s m3-vocab-cell__note">{v.note}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="m3-eng__principles">
            {E.principles.map((p) => (
              <div key={p.n} className="md-card md-card--filled m3-principle reveal">
                <div className="m3-principle__n md-title-m">{p.n}</div>
                <div className="md-title-l">{p.title}</div>
                <div className="md-body-m dim">{p.body}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
